import type { FC } from 'react';
import LanguageCard from './language_card';
import Language from './language';
import withLanguageForm from './with_language_form';
import LanguageThemeProvider from './language_theme_provider';
import { CardColumnContainer, CardColumn } from './card_dropdown_parts';

interface LanguageContainerProps {
   leftColumn: Array<Language>;
   rightColumn: Array<Language>;
   onClickLanguage: (langId: string) => void;
}

const LanguageContainer: FC<LanguageContainerProps> = ({
   leftColumn,
   rightColumn,
   onClickLanguage,
}) => (
   <CardColumnContainer>
      <CardColumn>
         {leftColumn.map((language: Language) => (
            <LanguageCard
               key={language.isoCode}
               language={language}
               onClickLanguage={onClickLanguage}
            />
         ))}
      </CardColumn>
      <CardColumn>
         {rightColumn.map((language: Language) => (
            <LanguageCard
               key={language.isoCode}
               language={language}
               onClickLanguage={onClickLanguage}
            />
         ))}
      </CardColumn>
   </CardColumnContainer>
);

const LanguageContainerWithForm = withLanguageForm(LanguageContainer);

interface LanguageDropdownProps {
   className?: string;
   translationPreferencesUrl: string;
   languages: Array<Language>;
   isLightTheme: boolean;
   mobile?: boolean;
}

const LanguageDropdown: FC<LanguageDropdownProps> = ({
   languages,
   translationPreferencesUrl,
   isLightTheme,
   mobile = false,
}) => {
   const leftColumn: Language[] = [];
   const rightColumn: Language[] = [];

   languages.forEach((language, index) => {
      if (index % 2 === 0) {
         leftColumn.push(language);
      } else {
         rightColumn.push(language);
      }
   });

   return (
      <LanguageThemeProvider isLightTheme={isLightTheme} mobile={mobile}>
         <LanguageContainerWithForm
            leftColumn={leftColumn}
            rightColumn={rightColumn}
            translationPreferencesUrl={translationPreferencesUrl}
         />
      </LanguageThemeProvider>
   );
};

export default LanguageDropdown;
